module.exports = __webpack_public_path__ + "img/loading.8e12125.png";